import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = match[1];

    api.post("/auth/session", { session_id: sessionId })
      .then((r) => {
        // clear hash and go to admin
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/admin", { replace: true, state: { user: r.data } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF9]">
      <div className="text-center">
        <div className="h-10 w-10 mx-auto rounded-full border-4 border-[#064E3B] border-t-transparent animate-spin" />
        <p className="mt-4 text-sm font-semibold text-[#064E3B]">Signing you in...</p>
      </div>
    </div>
  );
}
